import styled from '@emotion/styled'
import { SPACING } from 'constants/spacing.constants'

export const Column = styled.div<{
    fullHeight?: boolean
    fullWidth?: boolean
    gap?: keyof typeof SPACING
    p?: keyof typeof SPACING
    pr?: keyof typeof SPACING
    pl?: keyof typeof SPACING
    pt?: keyof typeof SPACING
    alignItems?: React.CSSProperties['alignItems']
    justifyContent?: React.CSSProperties['justifyContent']
    bgColor?: string
    br?: keyof typeof SPACING
}>`
    display: flex;
    flex-direction: column;
    ${({ gap }) => gap && `gap: ${SPACING[gap]};`}

    ${({ bgColor }) => bgColor && `background-color: ${bgColor};`}
    ${({ p }) =>
        // @NOTE: padding should come before pl and pr to allow for overrides.
        p && `padding: ${SPACING[p]};`}
    ${({ pl }) => pl && `padding-left: ${SPACING[pl]};`}
    ${({ pt }) => pt && `padding-top: ${SPACING[pt]};`}
    ${({ pr }) => pr && `padding-right: ${SPACING[pr]};`}
    ${({ br }) => br && `border-radius: ${SPACING[br]};`}

    ${({ alignItems }) => alignItems && `align-items: ${alignItems};`}
    ${({ fullHeight }) => fullHeight && `height: 100%;`}
    ${({ fullWidth }) => fullWidth && `width: 100%;`}
    ${({ justifyContent }) =>
        justifyContent && `justify-content: ${justifyContent};`}
`
